import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col} from 'reactstrap';
import { connect } from 'react-redux'

import {clearClubs} from '../club/SelectClubActions';
import FavIcon from '../app/FavIcon';
import UnionCard from './UnionCard';

import './SelectUnion.css';


class SelectUnion extends Component {
  constructor(props) {
      super(props);

      this.unionClicked = this.unionClicked.bind(this);
  }

  unionClicked(union) {
    this.props.clearClubs();
    let newUnion = encodeURIComponent(union);
    this.props.history.push("/" + newUnion);
  }


  render() {
      return (
          <div className="App ">
            <FavIcon isKNVB={false} />

            <Container fluid={true}>
              <Row className="Header">

                <div className="mx-auto" id="union-logo">
                  <img src="/img/sportlink_logo.png" alt="Sportlink logo" />
                </div>
              </Row>

              <Row>
                <Container className="Content ContentWhite">
                  <Row>
                     <Col md={{ size: 8,offset: 2 }}>
                       <h1>
                         Lid worden
                       </h1>
                       <p> Leuk dat je lid wilt worden! Kies hier eerst jouw sport.</p>
                     </Col>
                  </Row>

                  <Row className="UnionOverviewRow">
                    <Col sm="3">
                      <UnionCard unionid="JBN" description="Judo" onClick={this.unionClicked} />
                    </Col>
                    <Col sm="3">
                      <UnionCard unionid="KNAU" description="Atletiek" onClick={this.unionClicked} />
                    </Col>
                    <Col sm="3">
                      <UnionCard unionid="KBHB" description="Hockey (België)" onClick={this.unionClicked} />
                    </Col>
                    <Col sm="3">
                      <UnionCard unionid="KNBSB" description="Baseball en Softball" onClick={this.unionClicked} />
                    </Col>
                  </Row>

                  <Row className="UnionOverviewRow">
                    <Col sm="3">
                      <UnionCard unionid="KNKV" description="Korfbal" onClick={this.unionClicked} />
                    </Col>
                    <Col sm="3">
                      <UnionCard unionid="KNVB" description="Voetbal" onClick={this.unionClicked}  />
                    </Col>
                    <Col sm="3">
                      <UnionCard unionid="KNZB" description="Zwemmen" onClick={this.unionClicked}  />
                    </Col>
                    <Col sm="3">
                      <UnionCard unionid="NBB" description="Basketbal" onClick={this.unionClicked} />
                    </Col>
                  </Row>

                  <Row className="UnionOverviewRow">
                    <Col sm="3">
                      <UnionCard unionid="NeVoBo" description="Volleybal" onClick={this.unionClicked} />
                    </Col>
                    <Col sm="3">
                      <UnionCard unionid="NHV" description="Handbal" onClick={this.unionClicked} />
                    </Col>
                    <Col sm="3">
                      <UnionCard unionid="Redned" description="Reddingsbrigade" onClick={this.unionClicked} />
                    </Col>
                    <Col sm="3">
                      <UnionCard unionid="Generic" description="Overige sporten" onClick={this.unionClicked} />
                    </Col>

                  </Row>


                </Container>
              </Row>
              <Row>
                <div className="ml-auto">
                  <img className="sl-logo" src="/img/sportlink_logo.png" alt="Sportlink logo" />
                </div>
              </Row>

            </Container>
          </div>
      );
  }
}

SelectUnion.propTypes = {
  history: PropTypes.object.isRequired,
}


const mapStateToProps = state => ({
})


const mapDispatchToProps = dispatch => ({
  clearClubs: () => dispatch(clearClubs()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectUnion)



// WEBPACK FOOTER //
// ./src/union/SelectUnion.jsx